import {
    localStorage as dibsLocalStorage,
    sessionStorage as dibsSessionStorage,
} from 'dibs-browser-storage';

const NO_ZIP_CODE_FOUND = '0';

export const setUserSessionZipCode = userZipCode =>
    dibsSessionStorage.setItem('sessionUserZipCode', userZipCode);

export const setUserSessionGeoInfoByIpAddress = userGeoInfo =>
    dibsSessionStorage.setItem('ipAddressUserGeoInfo', userGeoInfo);

export const getUserSessionGeoInfoByIpAddress = () =>
    dibsSessionStorage.getItem('ipAddressUserGeoInfo') || '';

export const getUserSessionCountryCode = () => {
    const userGeoInfo = getUserSessionGeoInfoByIpAddress();
    return userGeoInfo?.countryCode || '';
};

export const hasUserSessionGeoInfoByIpAddress = () => !!getUserSessionGeoInfoByIpAddress();

export const hasUserSessionCountryCode = () => !!getUserSessionCountryCode();

export const getUserZipCode = () => {
    const userGeoInfo = dibsLocalStorage.getItem('userGeoInfo');
    const userSessionZipCode = dibsSessionStorage.getItem('sessionUserZipCode') || '';
    return userSessionZipCode.toString() || userGeoInfo?.zipCode || NO_ZIP_CODE_FOUND;
};
